import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isOpen: false,
  isRequestAccess: false
};

const popupSlice = createSlice({
  name: "popup",
  initialState,
  reducers: {
    openPopup(state) {
      state.isOpen = true;
    },
    closePopup(state) {
      state.isOpen = false;
    },
    togglePopup(state) {
      state.isOpen = !state.isOpen;
    },
    setIsRequestAccess(state) {
      state.isRequestAccess = true;
    }
  }
});

export const { openPopup, closePopup, togglePopup, setIsRequestAccess } = popupSlice.actions;

export default popupSlice.reducer;
